// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnergySavingView_patterns-list__g9c7M {
  display: flex;
  gap: 1rem;
  flex-direction: column;
}

.EnergySavingView_container__R-fig {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  row-gap: 3rem;
  align-items: start;
}
@media only screen and (max-width: 110rem) {
  .EnergySavingView_container__R-fig {
    grid-template-columns: 1fr 1fr;
  }
}
@media only screen and (max-width: 64rem) {
  .EnergySavingView_container__R-fig {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/EnergySaving/EnergySavingView.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,kCAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EAPF;IAQI,8BAAA;EAEF;AACF;AADE;EAVF;IAWI,0BAAA;EAIF;AACF","sourcesContent":[".patterns-list {\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n}\n\n.container {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 1rem;\n  row-gap: 3rem;\n  align-items: start;\n}\n@media only screen and (max-width: 110rem) {\n  .container {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media only screen and (max-width: 64rem) {\n  .container {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"patterns-list": `EnergySavingView_patterns-list__g9c7M`,
	"container": `EnergySavingView_container__R-fig`
};
export default ___CSS_LOADER_EXPORT___;
